<div *ngIf="isLoading" class="overlay">
  <div class="spinner"></div>
</div>
<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div
      class="col-4 col-md-2"
      *ngFor="let card of resumenCardsTwo; index as i"
    >
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 1 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 1, 'text-white': i !== 1 }"
              >
                <!-- {{ card.value }} -->
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 1 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 2 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-5">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mb-4">
    <div class="card">
      <div class="card-header">
        <div class="card-tools">
          <!-- <div class="row mb-6 justify-content-center">
          <div class="col-md-6 text-center">
            <a class="btn btn-dark btn-sm btn-initial" (click)="auth()">
              Connect Account
            </a>
          </div>
        </div> -->
          <a
            [routerLink]="['/billing/invoices/add']"
            class="btn btn-dark btn-sm btn-new"
          >
            New invoice
          </a>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead class="thead">
              <tr>
                <th><strong>INVOICE</strong></th>
                <th><strong>DATE</strong></th>
                <!-- <th>Order</th> -->
                <th><strong>CUSTOMER</strong></th>
                <th><strong>STATUS</strong></th>
                <th><strong>MODIFIED</strong></th>
                <th><strong>EXPIRATION</strong></th>
                <!--  <th>Quantity</th> -->
                <th><strong>BALANCE</strong></th>
                <th><strong>ACTIONS</strong></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of data">
                <td>
                  <!-- <a [routerLink]="['/billing/invoices/edit', item.invoice_id]">
                  {{ item.invoice_number }}
                </a> -->
                  <a class="a__invoice" (click)="getInvoice(item.invoice_id)">
                    {{ item.invoice_number }}
                  </a>
                </td>
                <td>{{ item.date }}</td>
                <!-- <td></td> -->
                <td>{{ item.customer_name }}</td>
                <td></td>
                <td></td>
                <!-- <td>{{ item.due_days }}</td> -->
                <td>{{ item.due_date }}</td>
                <!-- <td>{{ item.total }}</td> -->
                <td>{{ item.balance }}</td>
                <td class="text-center">
                  <a
                    [routerLink]="['/billing/invoices/edit', item.invoice_id]"
                    class="btn btn-link text-dark btn-sm p-2 btn-del"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <button
                    (click)="deleteData(item.invoice_id)"
                    class="btn btn-link text-dark btn-sm p-2 btn-del"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
